import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-exam-criteria-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
  templateUrl: './exam-criteria-list.component.html',
  styleUrls: ['./exam-criteria-list.component.scss'],
})
export class ExamCriteriaListComponent {
  /** HTML brut des critères d'évaluation (généré par le back) */
  evaluationCriteria = input.required<string>();

  /**
   * Normalise le HTML des critères pour un rendu homogène :
   * les paragraphes multi-lignes du back sont convertis en liste ordonnée.
   */
  displayCriteria = computed(() => normalizeCriteriaHtml(this.evaluationCriteria()));
}

/** Transforme un bloc <p> avec tirets ou <br> en <ul><li> pour le style à puces. */
function normalizeCriteriaHtml(html: string): string {
  const trimmed = (html || '').trim();
  if (!trimmed) {
    return '';
  }
  if (/<ol[\s>]|<ul[\s>]/i.test(trimmed)) {
    return trimmed;
  }

  const paragraphMatch = trimmed.match(/^<p[^>]*>([\s\S]*)<\/p>$/i);
  const inner = paragraphMatch ? paragraphMatch[1] : trimmed;
  const lines = inner
    .split(/<br\s*\/?>/i)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length <= 1) {
    return trimmed;
  }

  const items = lines
    .map((line) => line.replace(/^[-•*]\s*/, '').trim())
    .filter(Boolean)
    .map((line) => `<li>${line}</li>`)
    .join('');

  return items ? `<ul>${items}</ul>` : trimmed;
}
